import React, { useState, useRef } from "react";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  Tooltip,
} from "@mui/material";
import {
  Workspaces as ClusteringIcon,
  Room as MarkersIcon,
  BookmarkBorder as LabelsIcon,
  Map as MapTypesIcon,
  Close as CloseIcon,
  BorderOuter as BorderOuterIcon,
  AccessTime as AccessTimeIcon,
  ModeOfTravel as ModeOfTravelIcon,
  Radar as RadarIcon,
  TrackChanges as TrackChangesIcon,
  CarCrash as CarCrashIcon,
  RvHookup as RvHookupIcon,
} from "@mui/icons-material";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";

import { LOAD_STATUS, VEHICLE_STATUS } from "common/config";
import { LABELS } from "common/labels";
import { DEFAULTS } from "common/config";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ChkBox from "components/Custom/ChkBox";

const loadStatus = LOAD_STATUS;
const vehStatus = VEHICLE_STATUS;

const MapFilters = (props: any) => {
  const {
    clustering,
    showMarkers,
    showLabels,
    showAreas,
    showRadar,
    showTrips,
    showDelay,
    radarData,
    vehicles,
    showVehicles,
    futureVehicle,
    radarMainVehicle,
    setShowRadar,
    setFutureVehicle,
    selectedMapType,
    setClustering,
    setShowMarkers,
    setShowLabels,
    setSelectedMapType,
    setFutureViewVehicles,
    futureViewVehicles,
    updateLocation,
    locMarker,
    setShowAreas,
    setShowTrips,
    setTripDelivery,
    setRadarMainVehicle,
    setShowVehicles,
    setRadarData,
    setShowDelay,
    setVehicles,
    setDetails,
  } = props;

  const [anchorMapTypes, setAnchorMapTypes] =
    useState<HTMLButtonElement | null>(null);
  const [address, setAddress] = useState("");
  const [loadState, setLoadStatus] = useState<boolean>(false);
  const [vehicleStatus, setVehicleStatus] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const showMapTypes = Boolean(anchorMapTypes);
  const [vStatus, setVStatus] = useState<any>(vehStatus);
  const [tStatus, setTStatus] = useState<any>(loadStatus);

  const vehiclesdata = useRef(vehicles);
  const vehData = vehiclesdata.current;

  //for vehicle status
  const onCheckVehicleStatus = (checked, f) => {
    let tmpList = vStatus;
    // check is exists ??
    if (vStatus.indexOf(f) === -1) {
      tmpList.push(f);
    } else {
      tmpList = vStatus.filter((s) => s !== f);
    }
    if (f === "All") {
      if (checked) {
        tmpList = vehStatus;
      } else {
        tmpList = [];
      }
    } else {
      if (tmpList.length !== vehStatus.length) {
        tmpList = tmpList.filter((word) => word !== "All");
      }
    }

    setVStatus([...tmpList]);
    onStatusFilter(tStatus, tmpList);
  };
  //for trip status
  const onCheckTripStatus = (checked, f) => {
    let tripList = tStatus;
    if (tStatus.indexOf(f) === -1) {
      tripList.push(f);
    } else {
      tripList = tStatus.filter((s) => s !== f);
    }
    if (f === "All") {
      if (checked) {
        tripList = loadStatus;
      } else {
        tripList = [];
      }
    } else {
      if (tripList.length !== vehStatus.length) {
        tripList = tripList.filter((word) => word !== "All");
      }
    }
    setTStatus([...tripList]);
    onStatusFilter(tripList, vStatus);
  };

  //common function
  const onStatusFilter = (t, v) => {
    if (t.indexOf("All") > -1 && v.indexOf("All") > -1) {
      // Show All Vehicles => Master Data
      setVehicles(vehData);
    } else if (t.indexOf("All") > -1 && v.indexOf("All") === -1) {
      // Check only for vehicle status => filter Master Data
      const vdata = v.map((v) => v.toLowerCase());
      const vehicleState = vehData.filter((vehicle) =>
        vdata.includes(vehicle.vehicleStatus)
      );
      setVehicles(vehicleState);
    } else if (t.indexOf("All") === -1 && v.indexOf("All") > -1) {
      // Check only for trip status
      const tdata = t.map((t) => t.toLowerCase());
      const tripState = vehData.filter((trip) =>
        tdata.includes(trip.tripStatus)
      );
      setVehicles(tripState);
    } else {
      // Filter Both => tripstatus && vehiclestatus
      let vState = v.map((v) => v.toLowerCase());
      let tState = t.map((t) => t.toLowerCase());
      const vehicleState = vehData.filter((trip) =>
        vState.includes(trip.vehicleStatus)
      );
      const tripState = vehData.filter((trip) =>
        tState.includes(trip.tripStatus)
      );
      const tripVehicleStatus = [...vehicleState, ...tripState];
      const seenIds = new Set();
      const allTrips = tripVehicleStatus.filter((obj) => {
        if (!seenIds.has(obj.vehicleId)) {
          seenIds.add(obj.vehicleId);
          return true;
        }
        return false;
      });

      setVehicles(allTrips);
    }
    // Update state
  };

  const onClickMapTypes = (event: any) => {
    setAnchorMapTypes(event.currentTarget);
  };

  const onCloseMapTypes = () => {
    setAnchorMapTypes(null);
  };

  const onLatLngSearch = () => {
    let val: any = (
      document.getElementById("mapSearch") as HTMLInputElement
    ).value.trim();
    if (val) {
      val = val.split(",");
      if (val.length === 2) {
        const lat = Number(val[0]);
        const lng = Number(val[1]);
        if (!isNaN(lat) && !isNaN(lat)) {
          updateLocation({ lat, lng });
        }
      }
    }
  };

  const onAddressChange = (address) => {
    setAddress(address);
  };

  const onAddressSelect = (address) => {
    let self = this;
    setAddress(address);
    geocodeByAddress(address)
      .then((results) => {
        console.log("results: ", results);
        const loc = results[0].geometry.location;
        const lat = loc.lat();
        const lng = loc.lng();
        updateLocation({ lat, lng }, DEFAULTS.MAX_ZOOM - 3);
      })
      .catch((error) => console.error("Error", error));
  };

  let mapSearchValue = "";
  if (locMarker.lat) {
    mapSearchValue = locMarker.lat + "," + locMarker.lng;
  }

  const handleLoadStatus = (event) => {
    setAnchorEl(event.currentTarget);
    setLoadStatus(true);
  };
  const handleVehStatus = (event) => {
    setAnchorEl(event.currentTarget);
    setVehicleStatus(true);
  };

  const handlePopoverClose = () => {
    setVehicleStatus(false);
    setLoadStatus(false);
  };

  return (
    <div className="mapControls">
      <List>
        <ListItem
          disablePadding
          onClick={() => setClustering(!clustering)}
          className={clustering ? "active" : ""}
        >
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <Tooltip title={LABELS.CLUSTERING}>
                <ClusteringIcon />
              </Tooltip>
            </ListItemIcon>
          </ListItemButton>
        </ListItem>

        <ListItem
          disablePadding
          onClick={() => {
            setShowMarkers(!showMarkers);
            setTripDelivery(false);
            setDetails(false);
          }}
          className={showMarkers ? "active" : ""}
        >
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <Tooltip title={LABELS.MARKERS}>
                <MarkersIcon />
              </Tooltip>
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
        <ListItem
          disablePadding
          onClick={() => setShowLabels(!showLabels)}
          className={showLabels ? "active" : ""}
        >
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <Tooltip title={LABELS.MARKER_LABELS}>
                <LabelsIcon />
              </Tooltip>
            </ListItemIcon>
          </ListItemButton>
        </ListItem>

        <ListItem
          disablePadding
          onClick={() => setShowAreas(!showAreas)}
          className={showAreas ? "active" : ""}
        >
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <Tooltip title={LABELS.MAP_AREAS}>
                <BorderOuterIcon />
              </Tooltip>
            </ListItemIcon>
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding onClick={onClickMapTypes} className={"active"}>
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <Tooltip
                title={
                  LABELS.MAP_TYPES +
                  " ( " +
                  DEFAULTS.MAP_TYPES[selectedMapType] +
                  " )"
                }
              >
                <MapTypesIcon />
              </Tooltip>
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <div
            className="flexRow"
            style={{ alignItems: "center", position: "relative", top: -2 }}
          >
            <TxtBox
              id={"mapSearch"}
              placeholder={"78.255666,13.465464"}
              defaultValue={mapSearchValue}
            />
            <div className="searchBtnOnMap">
              <Btn text={LABELS.SEARCH} onClick={onLatLngSearch} />
            </div>
          </div>
        </ListItem>

        <ListItem
          onClick={() => {
            setShowVehicles(!showVehicles);
            setFutureVehicle(futureVehicle);
            setShowMarkers(true);
            setShowTrips(false);
            setTripDelivery(false);
            setDetails(false);
          }}
          className={showVehicles ? "active" : ""}
          style={{ paddingLeft: "35px" }}
        >
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <Tooltip title={LABELS.FUTURE_VIEW}>
                <AccessTimeIcon />
              </Tooltip>
            </ListItemIcon>
          </ListItemButton>
        </ListItem>

        {futureVehicle && (
          <ListItem
            disablePadding
            onClick={() => {
              setFutureVehicle(!futureVehicle);
              setFutureViewVehicles(futureViewVehicles);
            }}
            className={futureVehicle ? "active" : ""}
          >
            <ListItemButton className="listItemBtn">
              <CloseIcon />
            </ListItemButton>
          </ListItem>
        )}
        <ListItem
          disablePadding
          onClick={() => {
            setShowTrips(!showTrips);
            setTripDelivery(false);
            setDetails(false);
            setShowMarkers(true);
            setRadarMainVehicle(null);
          }}
          className={showTrips ? "active" : ""}
        >
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <Tooltip title={LABELS.TRIP_DELIVERIES}>
                <ModeOfTravelIcon />
              </Tooltip>
            </ListItemIcon>
          </ListItemButton>
        </ListItem>

        {showTrips && (
          <ListItem
            disablePadding
            onClick={() => {
              setShowTrips(!showTrips);
              setDetails(false);
              setTripDelivery(null);
              setShowMarkers(true);
              setShowAreas(true);
            }}
            className={futureVehicle ? "active" : ""}
          >
            <ListItemButton className="listItemBtn">
              <CloseIcon />
            </ListItemButton>
          </ListItem>
        )}

        <ListItem
          disablePadding
          onClick={() => {
            setShowRadar(!showRadar);
            setShowTrips(false);
          }}
          className={showRadar ? "active" : ""}
        >
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <Tooltip title={LABELS.RADAR}>
                <RadarIcon />
              </Tooltip>
            </ListItemIcon>
          </ListItemButton>
        </ListItem>

        {radarMainVehicle && (
          <ListItem
            disablePadding
            onClick={() => {
              setRadarMainVehicle(null);
              setRadarData(null);
              setClustering(true);
              setShowAreas(true);
            }}
            className={radarData ? "active" : ""}
          >
            <ListItemButton className="listItemBtn">
              <CloseIcon />
            </ListItemButton>
          </ListItem>
        )}

        <ListItem
          disablePadding
          onClick={() => {
            setShowDelay(!showDelay);
            setClustering(!clustering);
          }}
          className={showDelay ? "active" : ""}
        >
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <Tooltip title={LABELS.VEHICLE_DELAYS}>
                <TrackChangesIcon />
              </Tooltip>
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
        {/* FILTERS */}

        <ListItem
          disablePadding
          onClick={handleLoadStatus}
          className={tStatus ? "active" : ""}
        >
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <Tooltip title={LABELS.LOAD_STATUS}>
                <RvHookupIcon />
              </Tooltip>
            </ListItemIcon>
          </ListItemButton>
        </ListItem>

        <ListItem
          disablePadding
          onClick={handleVehStatus}
          className={vStatus ? "active" : ""}
        >
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <Tooltip title={LABELS.VEHICLE_STATUS}>
                <CarCrashIcon />
              </Tooltip>
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
      </List>

      <div>
        <Popover
          open={loadState}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <div style={{ marginLeft: "20px" }}>
            {loadStatus.map((item, index) => (
              <tr>
                <td>
                  <ChkBox
                    id={item}
                    text={item}
                    controlled={true}
                    checked={tStatus.indexOf(item) > -1}
                    onChange={(e, f) => {
                      onCheckTripStatus(e, f);
                    }}
                  />
                </td>
              </tr>
            ))}
          </div>
        </Popover>
      </div>
      <div>
        <Popover
          open={vehicleStatus}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <div style={{ marginLeft: "20px" }}>
            {vehStatus.map((item, index) => (
              <tr>
                <td>
                  <ChkBox
                    id={item}
                    text={item}
                    controlled={true}
                    checked={vStatus.indexOf(item) > -1}
                    onChange={(e, f) => {
                      onCheckVehicleStatus(e, f);
                    }}
                  />
                </td>
              </tr>
            ))}
          </div>
        </Popover>
      </div>
      <div>
        <Popover
          anchorEl={anchorMapTypes}
          onClose={onCloseMapTypes}
          open={showMapTypes}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <List className="mapTypes uiPopOver">
            {DEFAULTS.MAP_TYPES.map((m, i) => {
              return (
                <ListItem
                  key={"mtype-" + i}
                  disablePadding
                  onClick={() => {
                    setSelectedMapType(i);
                    onCloseMapTypes();
                  }}
                  className={i === selectedMapType ? "active" : ""}
                >
                  <ListItemButton>
                    {/* <ListItemIcon className="listIcon">
                      <MapTypesIcon />
                    </ListItemIcon> */}
                    <ListItemText primary={m} className="listText" />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Popover>
      </div>
      <PlacesAutocomplete
        value={address}
        searchOptions={{
          componentRestrictions: {
            country: "in",
          },
        }}
        onChange={onAddressChange}
        onSelect={onAddressSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div className={showTrips ? "tripSet" : "googlePlaceSearch"}>
            <input
              {...getInputProps({
                placeholder: "Address Search",
                className: "",
                id: "gSearchPlace",
              })}
            />
            <div className="autocomplete-dropdown-container">
              {suggestions.map((suggestion) => {
                const className = suggestion.active
                  ? "suggestion-item--active"
                  : "suggestion-item";
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: "#fafafa", cursor: "pointer" }
                  : { backgroundColor: "#ffffff", cursor: "pointer" };
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    </div>
  );
};

export default MapFilters;
